import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import {PostHogProvider} from 'posthog-js/react';
import App from './App';
import reportWebVitals from './reportWebVitals';

const font = new FontFace('Awesome Font', 'url(/fonts/interstate-black.ttf)', {
  style: 'normal',
  weight: '400',
});

font.load().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  const apiKey = 'phc_47Q1Z4hHA5CgTCxwrqNvSgYHN9t4uFsqeTdzXSiUXu4';
  const host = 'https://us.i.posthog.com';

  posthog.init(apiKey, {
    api_host: host,
    defaults: '2025-11-30',
  });

  root.render(
    <React.StrictMode>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
